module.exports = "https://files.cnvos.lb.djnd.si/static/images/doodle_dobra-vecerja-2.png?102163d54902afd50c18a6233032217e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodle_dobra-vecerja-2.png
// module id = 118
// module chunks = 1 2